export function getUniqueObjects<T>(arr: T[]): T[] {
  const seen = new Set<string>();
  return arr.filter((item) => {
    const key = JSON.stringify(item);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
